<!--Mode Select-->
<div class="MainGrid2Col">
	<label *ngIf="EnableAdvancedMode == true">Mode:</label>
	<div *ngIf="EnableAdvancedMode == true">
		<input id="Basic" value="Basic" [(ngModel)]="IncidentOption" name="IncidentOption" type="radio" />
		<label for="Basic" style="margin-right: 10px">Basic</label>

		<input id="Advanced" value="Advanced" [(ngModel)]="IncidentOption" name="IncidentOption" type="radio" />
		<label for="Advanced">Advanced</label>
	</div>

	<label>Group Name:</label>
	<label class="InfoText">{{ GroupName }}</label>
</div>

<!--Incident Menu-->
<div class="TopMargin" [ngStyle]="{ 'max-width': popup_Width }">
	<caass-sgbasic-incident *ngIf="IncidentOption == 'Basic'" [user]="user" [SchoolID]="SchoolID" [SelectedGroup]="SelectedGroup"> </caass-sgbasic-incident>

	<caass-sgadvanced-incident *ngIf="IncidentOption == 'Advanced'" [user]="user" [SchoolID]="SchoolID" [SelectedGroup]="SelectedGroup">
	</caass-sgadvanced-incident>
</div>

<!--Buttons-->
<div class="Buttons" [style.marginBottom]="IncidentOption == 'Basic' ? '180px' : '0px'">
	<button class="btn btn-primary" (click)="onAdd()">Add Incident</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>
